import { NgModule } from "@angular/core";
import { S25LoadingInlineModule } from "../s25-loading/s25.loading.inline.module";
import { CommonModule } from "@angular/common";
import { PopoverModule } from "../s25-popover/popover.module";
import { FormsModule } from "@angular/forms";
import { S25PreferenceToggleComponent } from "../s25-preference-toggle/s25.preference.toggle.component";
import { S25qlSearchInputComponent } from "../s25-ql/s25ql.search.input.component";
import { S25qlSearchSimpleInputDropdown } from "../s25-ql/s25ql.search.simple.input.dropdown.component";
import { S25ObjectSearchComponent } from "./s25.object.search.component";
import { S25ModalModule } from "../s25-modal/s25.modal.module";
import { S25ObjectModule } from "../s25-object/s25.object.module";
import { S25DropdownPaginatedModule } from "../s25-dropdown/s25.dropdown.paginated.module";
import { S25ToggleButtonModule } from "../s25-toggle-button/s25.toggle.button.module";
import { S25CheckboxModule } from "../s25-checkbox/s25.checkbox.module";
import { S25ObjectSearchResultsListComponent } from "./s25.object.search.results.list.component";
import { S25TableModule } from "../s25-table/s25.table.module";
import { S25ConflictsModule } from "../s25-conflicts/s25.conflicts.module";
import { S25ObjectConflictComponent } from "./s25.object.conflict.component";
import { S25ObjectAddButtonComponent } from "./s25.object.add.button.component";
import { S25ItemModule } from "../s25-item/s25.item.module";
import { S25PipesModule } from "../../pipes/s25.pipes.module";
import { S25EditableModule } from "../s25-editable/s25.editable.module";
import { S25ShiftSelectableModule } from "../s25-shift-select/s25.shift.selectable.module";
import { S25IconComponent } from "../s25-icon/s25.icon.component";
import { S25InfoMessageModule } from "../s25-info-message/s25.info.message.module";
import { LayoutTimesComponent } from "./layout.times.component";

@NgModule({
    imports: [
        S25LoadingInlineModule,
        CommonModule,
        PopoverModule,
        FormsModule,
        S25ModalModule,
        S25ObjectModule,
        S25DropdownPaginatedModule,
        S25ToggleButtonModule,
        S25PreferenceToggleComponent,
        S25CheckboxModule,
        S25TableModule,
        S25ConflictsModule,
        S25ItemModule,
        S25PipesModule,
        S25EditableModule,
        S25ShiftSelectableModule,
        S25IconComponent,
        S25InfoMessageModule,
        S25qlSearchSimpleInputDropdown,
        S25qlSearchInputComponent,
        S25ObjectAddButtonComponent,
    ],
    exports: [
        S25ObjectSearchComponent,
        S25ObjectSearchResultsListComponent,
        S25ObjectConflictComponent,
        S25ObjectAddButtonComponent,
        LayoutTimesComponent,
    ],
    declarations: [
        S25ObjectSearchComponent,
        S25ObjectSearchResultsListComponent,
        S25ObjectConflictComponent,
        LayoutTimesComponent,
    ],
    providers: [
        S25ObjectSearchComponent,
        S25ObjectSearchResultsListComponent,
        S25ObjectConflictComponent,
        S25ObjectAddButtonComponent,
        LayoutTimesComponent,
    ],
})
export class S25ObjectSearchModule {}
